import styled from 'styled-components';
import { colorCSS } from '../../../styles';
export const Link = styled.a `
  color: ${colorCSS('N800')};
  display: flex;
  font-size: 1rem;
  gap: 0.25rem;
  text-decoration: none;
  transition: 0.2s gap ease;
  &:hover {
    gap: 0.5rem;
    color: ${colorCSS('N800')};
  }
`;
//# sourceMappingURL=HeaderTabLink.styles.js.map